module.exports = __webpack_public_path__ + "static/media/icon_nishiwaki_no_image.a5cdd16b.png";